import React, { useEffect, useState } from "react";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import { UsuarioPainel } from "../../../Models/Cadastros/Usuario/UsuarioPainel";
import { UsuarioPainelService } from "../../../Services/Cadastros/Usuario/UsuarioPainelService";
import DataGridCrudComponent from "../../../Components/Forms/DataGridCrudComponent";

const UsuarioPaineisTab = (props: any) => {
    const [usuarioPainel, setUsuarioPainel] = useState<any>(new UsuarioPainel());
    const [usuarioPaineis, setUsuarioPaineis] = useState<any[]>([]);
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const usuarioPainelService = new UsuarioPainelService()

    const usuarioPainelColunas: GridColDef[] = [
        { field: 'nome_painel', headerName: 'Nome do Painel', minWidth: 200, flex: 0.2, },
        { field: 'url_painel', headerName: 'URL do Painel', minWidth: 200, flex: 0.2, },
    ];

    useEffect(() => {
        if (props.usuario == null) {
            return;
        }

        loadDados();
    }, [props.usuario]);

    function loadDados() {
        props.usuario.usuario_paineis = props.usuario.usuario_paineis ?? [];
        setUsuarioPaineis(usuarioPainelService.selecionarValidos(props.usuario.usuario_paineis));
    }

    function editar(id: any) {
        let entity = props.usuario.usuario_paineis?.filter((e: any) => e.id == id)[0];
        setUsuarioPainel(JSON.parse(JSON.stringify(entity)));
    }

    function salvar() {
        let response = usuarioPainelService.salvar(usuarioPainel, props.usuario.usuario_paineis);
        if (!response.valid) {
            enqueueSnackbar(response.message, {variant: 'error'});
            return;
        }

        props.usuario.usuario_paineis = response.entities;
        loadDados();
        cancelar();
        enqueueSnackbar('Registro salvo com sucesso!', {variant: 'success'});
    }

    async function apagar(id: any) {
        await confirm({ title: "Deseja realmente apagar este registro?" });

        let response = usuarioPainelService.apagar(id, props.usuario.usuario_paineis);
        if (!response.valid) {
            enqueueSnackbar(response.message, {variant: 'error'});
            return;
        }

        props.usuario.usuario_paineis = response.entities;
        loadDados();
        enqueueSnackbar('Registro apagado com sucesso!', {variant: 'success'});
    }

    function cancelar() {
        setUsuarioPainel(new UsuarioPainel());
    }

    return (
        <div>
            <DataGridCrudComponent
                model={usuarioPaineis}
                save={salvar}
                cancel={cancelar}
                labelSave='Adicionar'
                gridEdit={editar}
                gridDelete={apagar}
                gridRows={usuarioPaineis}
                gridColumns={usuarioPainelColunas}
                gridHideFooter={true}
                gridFieldId='id'
                gridHeight={500}>
                <div className="col-md-4 mb-3">
                    <TextFieldComponent required label="Nome do Painel" model={usuarioPainel} field='nome_painel' />
                </div>

                <div className="col-md-3 mb-3">
                    <TextFieldComponent required label="URL do Painel" model={usuarioPainel} field='url_painel' />
                </div>
            </DataGridCrudComponent>
        </div>
    );
}

export default UsuarioPaineisTab;